
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { BidQuoteViewModel, IDocument, IExecutionResult, IPurchaseOrderInvoice, RequisitionItemViewModel, RequisitionSaveViewModel, RequisitionViewModel, TcmDocumentContext } from "@tylertech/tyler-api-types";

/**
 * RequisitionService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class RequisitionService {
    constructor(private readonly $apiService: ApiService) { }
    
    CanAdd(): Promise<IExecutionResult<boolean>> {
        return this.$apiService.sendAuth("IRequisitionService/CanAdd");
    }
    Delete(pRequisitionId: string): Promise<IExecutionResult<boolean>> {
        return this.$apiService.sendAuth("IRequisitionService/Delete", pRequisitionId);
    }
    ExportRequisitionForm(pReqId: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IRequisitionService/ExportRequisitionForm", pReqId);
    }
    Get(pRequisitionId: string): Promise<IExecutionResult<RequisitionViewModel>> {
        return this.$apiService.sendAuth("IRequisitionService/Get", pRequisitionId);
    }
    GetBidQuotes(pRequisitionId: string): Promise<BidQuoteViewModel[]> {
        return this.$apiService.sendAuth("IRequisitionService/GetBidQuotes", pRequisitionId);
    }
    GetItems(pRequisitionId: string): Promise<RequisitionItemViewModel[]> {
        return this.$apiService.sendAuth("IRequisitionService/GetItems", pRequisitionId);
    }
    GetReqInvoices(pRequisitionId: string): Promise<IPurchaseOrderInvoice[]> {
        return this.$apiService.sendAuth("IRequisitionService/GetReqInvoices", pRequisitionId);
    }
    GetTcmUrl(pDocument: TcmDocumentContext<RequisitionViewModel>): Promise<IExecutionResult<string>> {
        return this.$apiService.sendAuth("IRequisitionService/GetTcmUrl", pDocument);
    }
    RequisitionNumberIsAvailable(pRequisitionNumber: string): Promise<boolean> {
        return this.$apiService.sendAuth("IRequisitionService/RequisitionNumberIsAvailable", pRequisitionNumber);
    }
    Save(reqSave: RequisitionSaveViewModel): Promise<IExecutionResult<RequisitionSaveViewModel>> {
        return this.$apiService.sendAuth("IRequisitionService/Save", reqSave);
    }
}
